import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import Loader from '../../../../components/elements/Loader'
import { authHeader } from '../../../../utils'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../../../store/types'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewClassArm from '../../../../components/partials/classes/NewClassArm'
import { clearCreatedClassDivision, clearUpdatedClassDivision } from '../../../../store/actions/classesDivisionsActions'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'
import { fetchStudents } from '../../../../store/actions/studentsActions'
import AssignClassParent from '../../../../components/partials/classes/AssignClassParent'
import StaffTableSnippet from '../../../../components/partials/staff/StaffTableSnippet'
import ClassArmStudentsSelection from '../../../../components/partials/classes/ClassArmStudentsSelection'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import StudentCardHorizontal from '../../../../components/partials/students/StudentCardHorizontal'
import PencilSquareIcon from '../../../../components/elements/icons/PencilSquareIcon'
import EditClassArm from '../../../../components/partials/classes/EditClassArm';

const ClassDetails = () => {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const [classDetails, setClassDetails] = useState(null)
  const [classArms, setClassArms] = useState(null)
  const classesSelector = useSelector(state => state.classes)
  const { classId } = useParams()
  const [reload, setReload] = useState(1);

  useEffect(() => {
    const getClassDetails = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/classes/${classId}`, { headers })            

        setClassDetails(response.data.data)
        getClassArms()
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setLoading(false)
      }
    }

    const getClassArms = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/class-divisions?classId=${classId}&&expand=classParents,createdBy`, { headers })            

        setClassArms(response.data.data.classDivisions)
        setLoading(false)
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setLoading(false)
      }
    }

    getClassDetails()

    if(classesSelector.createdClassDivision !== null){
      dispatch({
        type: SET_SUCCESS,
        payload: classesSelector.createdClassDivision.data.message
      })
      dispatch(clearCreatedClassDivision())
      setCreatingClassArm(false)
    }


    if(classesSelector.updatedClassArm !== null){
      dispatch({
        type: SET_SUCCESS,
        payload: classesSelector.updatedClassArm.data.message
      })
      dispatch(clearUpdatedClassDivision())
      setEditingClassArm(false)
      setActiveClassArm(null)
    }

    return () => {
      
    }
  }, [classId, classesSelector.createdClassDivision, classesSelector.updatedClassArm, dispatch, reload])

  const [creatingClassArm, setCreatingClassArm] = useState(false)

  const [activeClassArm, setActiveClassArm] = useState(null)

  const studentsSelector = useSelector(state => state.students)
  useEffect(() => {
    if(activeClassArm){
      dispatch(fetchStudents(`currentClass=${classId}&classArm=${activeClassArm._id}`, 0, 0))
    }

    return () => {
      
    }
  }, [activeClassArm, classId, dispatch, reload])

  const [selectingClassParents, setSelectingClassParents] = useState(false)
  const [selectingStudents, setSelectingStudents] = useState(false)

  const [editingClassArm, setEditingClassArm] = useState(false)

  const removeClassParent = async (classParent) => {
    
    if(!window.confirm(`Are you sure you want to remove ${classParent.fullName} as a class parent from this class arm (${classDetails?.name}${activeClassArm?.label})?`)) return
    
    try {
      const headers = authHeader()
      const payload = {
        staff: classParent._id,
        classDivisionId: activeClassArm._id
      }

      await axios.delete(`${process.env.REACT_APP_BASE_URL}/class-divisions/remove-class-parents`, { headers, data: payload })

      dispatch({
        type: SET_SUCCESS,
        payload: 'Class parent removed successfully'
      })

      setReload(reload + 1)
      setActiveClassArm(null)

    } catch (error) {
      console.log('error removing class parent: ', error)
      dispatch({
        type: ERROR,
        error
      })
    }
  }
  
  return (
    <>
      <AdministrationLayout>
        <div className='w-full pb-8'>
            {loading ? 
              <Loader />
            :
              <div className='w-full'>
                <div className='flex items-center justify-between mb-[25px]'>
                  <div className='w-full'>
                    <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Class Name</label>
                    <div className='flex items-center justify-normal gap-x-2'>
                      <h3 className='font-medium font-orbitron'>{classDetails?.name}</h3>
                      <span className={`capitalize text-[12px] font-space-grotesk font-medium p-2 rounded ${classDetails?.type === 'JUNIOR' ? 'text-amber-800 bg-amber-200/20' : 'text-green-600 bg-green-200/20'}`}>{classDetails?.type?.toLowerCase()} Class</span>
                      <div className='flex items-center gap-x-[5px]'>
                        {/* {application.completed && <Link to={`${application.admission._id}/edit`} className='rounded-[8px]  text-xs bg-gray-100 p-[7px] text-gray-600 transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                          <PencilSquareIcon className='w-4 h-4' />
                          Edit Application Details
                        </Link>}
                        {application.completed && <button className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                          <ArrowDownTrayIcon className='w-4 h-4' />
                        </button>} */}
                        {/* <button onClick={()=>{setRejectingApplication(true)}} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                          <PrinterIcon className='w-4 h-4' />
                        </button> */}
                        
                      </div>
                    </div>
                  </div>
                </div>

                <div className='w-full flex items-start justify-between gap-x-[50px]'>
                  <div className='w-1/2 sticky top-20'>
                    <div className='w-full flex items-start justify-between'>
                      <div>
                        <h3 className='text-lg font-[550]'>Class Arms</h3>
                        <p className='text-sm font-[500]'>Select a class arm to load class parents and students or the right</p>
                      </div>
                      <button onClick={()=>{setCreatingClassArm(true)}} className='rounded-[8px] px-4 py-3 mt-2 text-sm text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                        <PlusIcon className='w-5 h-5' />
                        Create Class Arm
                      </button>
                    </div>

                    <div className='mt-[40px] w-full'>
                      {!classArms || classArms?.length === 0 ? 
                        <EmptyState emptyStateText={`No arms created yet for this class. Click on "Create Class Arm" above to create a new class arm`} />  
                      :
                        <div className='w-full'>
                          {classArms?.map((division, divisionIndex) =>(
                            <div key={divisionIndex} onClick={()=>{setActiveClassArm(division)}} className={`${activeClassArm?._id === division._id ? 'border-vcm-purple bg-vcm-light-purple bg-opacity-10 hover:bg-opacity-20' : 'bg-gray-50 border-transparent hover:bg-gray-100 hover:border-gray-400'} my-[20px] rounded-[8px] p-[15px]  cursor-pointer transition duration-200 border flex items-start gap-x-[10px] relative`}>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Class Name</label>
                                <h3 className='font-medium font-orbitron text-sm'>{division?.label} - {classDetails.name}{division.label}</h3>
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Class Parents</label>
                                {division.classParents.length === 0 ? 
                                  <p className='text-gray-400 text-xs'>No class parents assigned yet</p> : 
                                  <p className='text-sm text-gray-600'>{division.classParents.map(parent => {return `${parent.firstName} ${parent.lastName.charAt(0)}.`}).join(',')}</p>
                                }
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Max. Students</label>
                                <p className='font-space-grotesk text-sm'>{division.maxStudentCount}</p>
                              </div>
                              <div className='w-1/4'>
                                <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Current Students</label>
                                <p className='font-space-grotesk text-sm'>{division.totalStudents}</p>
                              </div>
                              <div className='w-[50px] h-[50px] flex items-center justify-center'>
                                {activeClassArm?._id === division._id && 
                                  <ArrowIcon className={`w-4 h-4 text-vcm-purple transition-all duration-500`} />
                                }
                              </div>
                            </div>
                          ))}
                        </div>
                    }
                    </div>
                  </div>
                  <div className='w-1/2 min-h-[800px] h-inherit border border-gray-200 rounded-[10px] bg-gray-50 p-[30px]'>
                    {!activeClassArm ? <div className='text-center'>
                      <h3 className='text-sm font-[500] mb-[5px]'>No class Arm Selected</h3>
                      <p className='text-sm text-gray-500 mt-[5px]'>Select a division fom the left to see full details here</p>
                    </div>
                    :
                    <div className='w-full'>
                      <div className='w-full mb-[30px] pb-[30px] border-b border-gray-300'>
                        <div className='w-full flex items-start justify-between'>
                          <div className='w-8/12'>
                            <h3 className='text-sm font-[500] mb-[5px]'>Class Parents</h3>
                            <p className='text-sm'>Below are the class parents for {classDetails.name}{activeClassArm.label}. You can have a maximum of two class parents for this class</p>

                            <button onClick={()=>{setEditingClassArm(true)}} className='px-4 py-2 mt-4 bg-gray-200 rounded-lg text-xs text-gray-500 hover:text-gray-900 font-semibold flex items-center justify-center gap-x-1 transition duration-200'><PencilSquareIcon className="w-4 h-4" /> Edit Class Arm</button>
                          </div>
                          {activeClassArm?.classParents?.length < 2 && <button onClick={()=>{setSelectingClassParents(true)}} className='rounded-[8px] px-3 py-2  text-xs text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                            <PlusIcon className='w-5 h-5' />
                            Assign a class parent
                          </button>}
                        </div>

                        {activeClassArm?.classParents?.length > 0 ? 
                          <div className='w-full mt-[20px]'>
                            {activeClassArm.classParents.map((parent, parentIndex)=>(
                              <div key={parentIndex} className='w-full flex items-start gap-x-[10px] my-[10px]'>
                                <div className='w-full bg-white p-[10px] rounded-[8px] flex items-center justify-between'>
                                  <StaffTableSnippet staff={parent} />
                                  <button onClick={()=>{removeClassParent(parent)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-red-200 hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-red-500 flex items-center justify-center text-xs gap-x-[5px]'>
                                    <TrashIcon className={`w-4 h-4`} />
                                    Remove Parent
                                  </button>
                                </div>
                                {/* <div>
                                  <label className='text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2 block'>DEPT/Designation</label>
                                  <p className='text-sm'>{parent.department.name} <span className='text-gray-400'>{parent.designation.name}</span></p>
                                </div> */}
                              </div>
                            ))}
                          </div>
                        :
                          <div className='mt-[30px]'>
                            <EmptyState emptyStateText={`No Class parents chosen for this class yet.`} />
                          </div>
                        }

                      </div>
                      {studentsSelector.loadingStudents ? 
                      <Loader />
                      :
                      <>
                        <div className='w-full flex items-start justify-between'>
                          <div className='w-8/12'>
                            <h3 className='text-sm font-[500] mb-[5px]'>Students</h3>
                            <p className='text-sm'>A list of students currently in {classDetails.name}{activeClassArm.label}. You can have a maximum of {activeClassArm.maxStudentCount} students for this class</p>
                          </div>
                          {<button onClick={()=>{setSelectingStudents(true)}} className='rounded-[8px] px-3 py-2  text-xs text-purple-100 bg-vcm-purple transition duration-200 font-space-grotesk border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-1'>
                            <PlusIcon className='w-5 h-5' />
                            Select Students
                          </button>}
                        </div>

                        {studentsSelector.students?.students?.length === 0 ? 
                          <div className='mt-[30px]'>
                            <EmptyState emptyStateText={`No students in ths class arm currently.`} />
                          </div>
                        :
                          <div className='grid grid-cols-2 gap-1 mt-[20px]'>
                            {[...(studentsSelector.students?.students || [])]
                              .sort((firstStudent, secondStudent) =>
                                (firstStudent.lastName || '').localeCompare(secondStudent.lastName || '')
                              )
                              .map((student, studentIndex) => (
                              <div className='w-full' key={studentIndex}>
                                <StudentCardHorizontal student={student} />
                              </div>
                            ))}
                          </div>
                        }
                        </>
                      }
                    </div>}
                  </div>
                </div>
              </div>
            }
          </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingClassArm} 
        closeFunction={()=>{setCreatingClassArm(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Create a class arm for ${classDetails?.name}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <NewClassArm 
          classId={classDetails?._id}
          pushClassArm={()=>{}}
          closeFunction={()=>{setCreatingClassArm(false)}} 
        />
      </ModalDialog>

      <ModalDialog
        shown={editingClassArm} 
        closeFunction={()=>{setEditingClassArm(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Edit a class arm for ${activeClassArm?.name}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <EditClassArm 
          classId={classDetails?._id}
          classArm={activeClassArm}
          pushClassArm={()=>{}}
          closeFunction={()=>{setEditingClassArm(false)}} 
        />
      </ModalDialog>

      <ModalDialog
        shown={selectingClassParents} 
        closeFunction={()=>{setSelectingClassParents(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Select class parents for ${classDetails?.name}${activeClassArm?.label}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <AssignClassParent 
          classId={classDetails?._id}
          classArmId={activeClassArm?._id}
          closeFunction={()=>{
            setSelectingClassParents(false)
            setReload(reload+1)}} 
        />
      </ModalDialog>

      <ModalDialog
        shown={selectingStudents} 
        closeFunction={()=>{setSelectingStudents(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Select students for ${classDetails?.name}${activeClassArm?.label}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <ClassArmStudentsSelection 
          classDetails={classDetails}
          classArm={activeClassArm}
          reload={()=>{setReload(reload+1)}}
          closeFunction={()=>{setSelectingStudents(false)}} 
        />
      </ModalDialog>
    </>
  )
}

export default ClassDetails